<template>
  <div class="friend-link-mobile-container">
    <!-- 操作栏 -->
    <div class="operation-bar">
      <el-button type="primary" size="large" @click="handleAdd" class="add-btn">
        <i class="el-icon-plus"></i> 新增友链
      </el-button>
    </div>

    <!-- 移动端卡片列表 -->
    <div class="card-list" v-loading="loading">
      <div 
        v-for="item in linkList" 
        :key="item.id" 
        class="link-card"
      >
        <div class="card-header">
          <div class="link-name">{{ item.link_name }}</div>
          <div class="link-status">
            <el-switch
              v-model="item.is_show"
              :active-value="1"
              :inactive-value="0"
              @change="handleStatusChange(item)"
              size="small"
            >
            </el-switch>
          </div>
        </div>
        
        <div class="card-content">
          <div class="link-url">
            <i class="el-icon-link"></i>
            <el-link type="primary" :href="item.link_url" target="_blank" class="url-text">
              {{ item.link_url }}
            </el-link>
          </div>
          <div class="description" v-if="item.description">{{ item.description }}</div>
          <div class="link-order">
            <span class="label">排序:</span>
            <span class="value">{{ item.link_order }}</span>
          </div>
        </div>
        
        <div class="card-actions">
          <el-button 
            size="mini" 
            type="primary" 
            @click="handleEdit(item)"
            class="action-btn"
          >
            编辑
          </el-button>
          <el-button 
            size="mini" 
            type="danger" 
            @click="handleDelete(item)"
            class="action-btn"
          >
            删除
          </el-button>
        </div>
      </div>
      
      <!-- 空状态 -->
      <div v-if="linkList.length === 0 && !loading" class="empty-state">
        <i class="el-icon-link"></i>
        <p>暂无友链数据</p>
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      append-to-body
      custom-class="mobile-dialog"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="名称" prop="link_name">
          <el-input v-model="form.link_name" placeholder="请输入友链名称" ref="linkNameInput"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="link_url">
          <el-input v-model="form.link_url" placeholder="请输入友链地址"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="form.description" type="textarea" :rows="3" placeholder="请输入友链描述"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="link_order">
          <el-input-number v-model="form.link_order" :min="1" :max="99" label="排序" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="是否显示" prop="is_show">
          <el-switch
            v-model="form.is_show"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="large">取 消</el-button>
        <el-button type="primary" @click="submitForm" size="large">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { isMobile } from '@/utils/device'

export default {
  name: 'FriendLinkMobile',
  data() {
    return {
      loading: false,
      linkList: [],
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        link_name: '',
        link_url: '',
        description: '',
        link_order: 0,
        is_show: 1
      },
      rules: {
        link_name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        link_url: [
          { required: true, message: '请输入链接', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true
        console.log('开始获取友链数据')
        const response = await request.get('/api/friend-links')
        console.log('获取到的友链数据:', response)
        
        // 检查响应格式并处理数据
        if (Array.isArray(response)) {
          this.linkList = response
        } else if (response && Array.isArray(response.data)) {
          this.linkList = response.data
        } else {
          this.linkList = []
          console.warn('未获取到有效的友链数据:', response)
          this.$message.warning('未获取到友链数据')
        }
        
        console.log('处理后的友链列表:', this.linkList)
      } catch (error) {
        console.error('获取友链列表失败:', error)
        if (error.response) {
          console.error('错误响应:', error.response)
          this.$message.error(error.response.data?.message || '获取友链列表失败')
        } else if (error.request) {
          console.error('请求未收到响应')
          this.$message.error('服务器未响应，请检查网络连接')
        } else {
          console.error('请求配置错误:', error.message)
          this.$message.error('请求配置错误')
        }
      } finally {
        this.loading = false
      }
    },
    
    handleAdd() {
      this.dialogTitle = '新增友链'
      this.form = {
        id: null,
        link_name: '',
        link_url: '',
        description: '',
        link_order: this.linkList.length + 1,
        is_show: 1
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        // 自动聚焦到名称输入框
        setTimeout(() => {
          this.$refs.linkNameInput && this.$refs.linkNameInput.focus()
        }, 100)
      })
    },
    
    handleEdit(row) {
      this.dialogTitle = '编辑友链'
      this.form = { ...row }
      this.dialogVisible = true
      this.$nextTick(() => {
        // 自动聚焦到名称输入框
        setTimeout(() => {
          this.$refs.linkNameInput && this.$refs.linkNameInput.focus()
        }, 100)
      })
    },
    
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该友链吗？', '提示', {
          type: 'warning',
          confirmButtonText: '删除',
          cancelButtonText: '取消'
        })
        await request.delete('/api/friend-links/' + row.id)
        this.$message.success('删除成功')
        this.fetchData()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除友链失败:', error)
          this.$message.error('删除友链失败')
        }
      }
    },
    
    async handleStatusChange(row) {
      try {
        await request.put('/api/friend-links/' + row.id + '/status', {
          is_show: row.is_show
        })
        this.$message.success('状态更新成功')
      } catch (error) {
        console.error('更新状态失败:', error)
        this.$message.error('更新状态失败')
        row.is_show = row.is_show === 1 ? 0 : 1 // 恢复状态
      }
    },
    
    async submitForm() {
      try {
        await this.$refs.form.validate()
        if (this.form.id) {
          await request.put('/api/friend-links/' + this.form.id, this.form)
        } else {
          await request.post('/api/friend-links', this.form)
        }
        this.$message.success(this.dialogTitle + '成功')
        this.dialogVisible = false
        this.fetchData()
      } catch (error) {
        if (error !== false) {
          console.error('提交友链失败:', error)
          this.$message.error('提交友链失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.friend-link-mobile-container {
  padding: 16px;
  min-height: 100vh;
  background-color: #f5f7fa;

  .operation-bar {
    margin-bottom: 20px;
    text-align: center;
    
    .add-btn {
      width: 100%;
      height: 48px;
      font-size: 16px;
      border-radius: 8px;
    }
  }

  .card-list {
    .link-card {
      background: #fff;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border: 1px solid #e4e7ed;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f0f0;

        .link-name {
          font-size: 18px;
          font-weight: 600;
          color: #303133;
          flex: 1;
        }

        .link-status {
          margin-left: 12px;
        }
      }

      .card-content {
        margin-bottom: 16px;

        .link-url {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          padding: 8px 12px;
          background: #f8f9fa;
          border-radius: 6px;

          i {
            color: #409eff;
            margin-right: 8px;
            font-size: 16px;
          }

          .url-text {
            flex: 1;
            word-break: break-all;
            font-size: 14px;
          }
        }

        .description {
          font-size: 14px;
          color: #606266;
          line-height: 1.5;
          margin-bottom: 12px;
          word-break: break-all;
        }

        .link-order {
          display: flex;
          align-items: center;

          .label {
            font-size: 14px;
            color: #909399;
            margin-right: 8px;
          }

          .value {
            font-size: 14px;
            color: #303133;
            font-weight: 500;
          }
        }
      }

      .card-actions {
        display: flex;
        gap: 12px;

        .action-btn {
          flex: 1;
          height: 36px;
        }
      }
    }

    .empty-state {
      text-align: center;
      padding: 60px 20px;
      color: #909399;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
      }

      p {
        font-size: 16px;
        margin: 0;
      }
    }
  }

  // 移动端对话框样式
  .mobile-dialog {
    .el-dialog {
      margin: 10vh auto !important;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

      .el-dialog__header {
        padding: 20px 20px 16px;
        background-color: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;
        text-align: center;
      }

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }

      .el-dialog__body {
        padding: 20px;
      }

      .el-dialog__footer {
        padding: 16px 20px 20px;
        border-top: 1px solid #f0f0f0;
        text-align: center;

        .el-button {
          width: 45%;
          height: 44px;
          font-size: 16px;
        }
      }
    }
  }
}

// 响应式调整
@media (max-width: 480px) {
  .friend-link-mobile-container {
    padding: 12px;

    .card-list .link-card {
      padding: 12px;
      margin-bottom: 12px;

      .card-actions {
        gap: 8px;
        
        .action-btn {
          height: 40px;
        }
      }
    }
  }
}
</style> 